import React from 'react';
import { IonIcon, IonButton } from '@ionic/react';
import { close } from 'ionicons/icons';
import Modal from './Modal';
import './AccountInformationModal.css';

interface AccountInformationModalProps {
  /** Whether the modal is open */
  isOpen: boolean;
  /** Callback fired when modal should close */
  onClose: () => void;
  /** Additional CSS class name */
  className?: string;
  /** Partner doing business as */
  partnerDoingBusinessAs: string;
}

function AccountInformationModal({
  isOpen,
  onClose,
  className = '',
  partnerDoingBusinessAs,
}: AccountInformationModalProps) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      className={className}
    >
      <div className="account-information-modal-content">
        <IonButton onClick={onClose} className="account-information-modal-close-button">
          <IonIcon icon={close} />
        </IonButton>
        <p className="account-information-modal-heading">
          What This Does:
        </p>
        <p className="account-information-modal-text">
          This setting lets you decide whether to share <strong>Account Information</strong> with {partnerDoingBusinessAs}.
        </p>
        <p className="account-information-modal-heading">
          Why This Matters!
        </p>
        <p className="account-information-modal-text">
          This information includes unique identifiers which connect all of the information about your activity in Lore.
        </p>
      </div>
    </Modal>
  );
}

export default AccountInformationModal;

